import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'slider-arrow',
    templateUrl: './slider-arrow.html',
    styleUrls: ['./slider-arrow.scss'],
    standalone: true,
    imports: [NgClass]
})
export class SliderArrowComponent {
    @Input()
    side: 'left' | 'right' = 'left';
}
